import { Map as immutableMap } from 'immutable';
import { getField, updateField } from 'vuex-map-fields';

const STEP = 0.5;
const MIN = 0.5;

const STATE = immutableMap({
  date: Date.now(),
  layoutScale: 1,
});

export const state = () => STATE.toJS();

export const getters = {
  getField,
};

export const mutations = {
  reset(state) {
    Object.assign(state, {
      ...STATE.toJS(),
      date: Date.now(),
    });
  },
  updateField,
};

export const actions = {
  adjustScale(context, amount) {
    const modifier = amount > 0 ? STEP : -STEP;
    const result = context.state.layoutScale + modifier;
    const layoutScale = result > 1
      ? 1
      : result < MIN
        ? MIN
        : result;
    context.commit('updateField', {
      path: 'layoutScale',
      value: layoutScale,
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
